import { pluginKey } from './plugin';
export var applyChange = function applyChange(tr) {
  return tr.setMeta(pluginKey, {
    changed: true
  });
};